import React from "react";
import { map } from "lodash";
import styled from "styled-components";
import { FontWeight, Spacing, content, transparentize } from "@glossy";

export interface IProps {
  sections: Section[];
  onClickSection: (id: string) => void;
}

type Section = {
  id: string;
  title: string;
  subsection: boolean;
  sections: Omit<Section, "sections">[];
};

const Root = styled.div`
  padding: ${Spacing.ExtraLarge} 0;
  line-height: 32px;
  > * + * {
    margin-top: ${Spacing.Medium};
  }
`;

const Title = styled.div`
  padding: 0 ${Spacing.ExtraLarge};
`;

const MainSection = styled.div`
  ${Title} {
    color: ${content};
    font-weight: ${FontWeight.Bold};
    cursor: pointer;
    :hover {
      background-color: ${(props) =>
        transparentize(0.85, content(props, "primary"))};
    }
  }
`;

const SubSection = styled(MainSection)`
  ${Title} {
    color: ${(props) => content(props, "secondary")};
    font-weight: ${FontWeight.Normal};
    :hover {
      background-color: ${(props) =>
        transparentize(0.85, content(props, "secondary"))};
    }
  }
`;

const PanelsCardLibrarySidebar = ({ sections, onClickSection }: IProps) => {
  return (
    <Root>
      {map(sections, ({ id, title, sections }) => (
        <MainSection key={id}>
          <Title onClick={() => onClickSection(id)}>{title}</Title>
          {map(sections, ({ title, subsection, id: idSubsection }, idx) => (
            <SubSection key={idx}>
              <Title
                onClick={() => onClickSection(subsection ? idSubsection : id)}
              >
                {title}
              </Title>
            </SubSection>
          ))}
        </MainSection>
      ))}
    </Root>
  );
};

export default PanelsCardLibrarySidebar;
